
import { Course } from '../types';

export const fhdra_basics: Course = {
  id: "fhdra_basics",
  title: "The First Hearing (FHDRA)",
  description: "The First Hearing Dispute Resolution Appointment. Your case starts here.",
  icon: "🏛️",
  totalModules: 11,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/fhdra_basics/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/fhdra_basics/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/fhdra_basics/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/fhdra_basics/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/fhdra_basics/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/fhdra_basics/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/fhdra_basics/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/fhdra_basics/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/fhdra_basics/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/fhdra_basics/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/fhdra_basics/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "What is the primary goal of the court during the First Hearing Dispute Resolution Appointment (FHDRA)?",
        "o": [
            "To immediately schedule a full, contested trial.",
            "To resolve issues through mediation or negotiation and avoid a full trial.",
            "To determine who is at fault for the dispute.",
            "To finalize all child arrangements without any prior discussion."
        ],
        "a": 1
    },
    {
        "q": "Before entering the courtroom for the FHDRA, with whom will you meet to review the Safeguarding Report?",
        "o": [
            "Your legal representative only.",
            "The Judge directly.",
            "A Cafcass officer.",
            "The opposing party's lawyer."
        ],
        "a": 2
    },
    {
        "q": "What is the recommended strategy regarding interim contact offers during the FHDRA?",
        "o": [
            "Decline all interim contact offers to avoid complications.",
            "Only accept interim contact if it perfectly aligns with your initial demands.",
            "Say yes to interim offers to build a 'pattern of success' and demonstrate focus on the child's needs.",
            "Postpone any decision on interim contact until a later hearing."
        ],
        "a": 2
    },
    {
        "q": "If a case cannot be fully settled at the FHDRA, what will the Judge issue, which are mandatory legal deadlines?",
        "o": [
            "Suggestions for further reading.",
            "Optional guidance documents.",
            "Directions.",
            "A recommendation for private arbitration."
        ],
        "a": 2
    },
    {
        "q": "What is the immediate outcome if parents reach a full agreement on a schedule during the FHDRA?",
        "o": [
            "The case is immediately escalated to a higher court.",
            "The Judge will issue a Final Consent Order, ending the court proceedings.",
            "Additional hearings are scheduled to review the agreement.",
            "The agreement is only considered a draft and not legally binding."
        ],
        "a": 1
    }
]
};
